// removed by extract-text-webpack-plugin
module.exports = {"header":"H-wKPQQdkWXMWWWR2jyfK","bar":"_1cjisgKTyuplCAr_qiimWx"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/components/NavigationWrapper/styles.scss
// module id = 621
// module chunks = 11